export { default as DevToolsManager } from './DevTools';
